import { fmtDateTime } from "@/lib/api";

function Slip({ title, order, items, store }) {
  return (
    <div className="ticket-page p-2">
      <p className="text-center font-bold">{store}</p>
      <p className="text-center font-bold text-sm">{title} · PEDIDO {order.number}</p>
      <p className="text-center">{order.label}</p>
      {order.customer && <p className="text-center font-bold text-sm">Cliente: {order.customer}</p>}
      <p className="text-center">{fmtDateTime(order.at)} · {order.user}</p>
      <p className="border-t border-dashed my-2" />
      {items.map((i, k) => <div key={k}><p className="font-bold">{i.qty}x {i.name}</p>{i.notes && <p>  Obs.: {i.notes}</p>}</div>)}
      {order.pickup_number && <div className="my-2 border-2 border-black py-1 text-center"><p className="text-[10px]">SENHA</p><p className="text-2xl font-extrabold">{String(order.pickup_number).padStart(3, "0")}</p></div>}
    </div>
  );
}

export function OrderPrint({ order, store }) {
  if (!order) return null;
  const want = (k) => !order.pending || order.pending.includes(k);
  return (
    <div className="hidden print:block print-area font-mono text-xs" data-testid="order-print">
      {want("main") && order.items.length > 0 && <Slip title="COMANDA" order={order} items={order.items} store={store} />}
      {order.sectors.filter((s) => want(s.id)).map((s) => <Slip key={s.sector} title={s.sector.toUpperCase()} order={order} items={s.items} store={store} />)}
    </div>
  );
}
